'use strict';
import React, { Component } from 'react';
import createClass from 'create-react-class';

import puzzle from "../lib/puzzle";
import Grid from "./game/Grid";



export default class Game extends React.Component {

  constructor(props) {
    super(props);
    const { seed, gridSize, colourCount, remove } = props;
    puzzle.setSeed(seed);
    const puzzleState = puzzle.generatePuzzle(gridSize, colourCount, remove);
    console.log(puzzleState);
    this.state = { puzzleState, moveCount: 0, complete: false }
  }

  render() {
    const { title } = this.props;
    const { moveCount, complete } = this.state;
    return (
      <div className={`game-container ${complete ? "complete" : ""}`}>
        <h3>{complete ? "Complete!" : title} </h3>
        <Grid gameState={this.state.puzzleState} onClick={this.updatePuzzle} />
        <p>{moveCount} move{moveCount === 1 ? "" : "s"} {moveCount > 0 && <a onClick={this.resetPuzzle}>Reset</a>}</p>
      </div>
    );
  }

  resetPuzzle = () => {
    const { gridSize } = this.props;
    for (let i = 1; i <= gridSize; i++) {
      for (let j = 1; j <= gridSize; j++) {
        if (this.state.puzzleState.rows[i][j].colour != -1)
          this.state.puzzleState.rows[i][j].colour = 0;
      }
    }
    this.setState(
      { puzzleState: this.state.puzzleState, moveCount: 0, complete: false }
    );
  };

  updatePuzzle = (item) => {
    if (!this.state.complete) {


      const { gridSize, colourCount } = this.props;

      let current = this.state.puzzleState.rows[item.y][item.x].colour;
      current++;
      if (current > colourCount) {
        current = 0;
      }
      this.state.puzzleState.rows[item.y][item.x].colour = current;
      this.setState({ puzzleState: this.state.puzzleState, moveCount: this.state.moveCount + 1 });

      if (puzzle.isSolution(this.state.puzzleState, gridSize, colourCount)) {
        this.completePuzzle();
      }
    }
  };

  completePuzzle = () => this.setState({ complete: true });
}


// WEBPACK FOOTER //
// ./src/components/rgb/components/Game.js